import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGitComponent } from './simple-icons-git.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGitComponent ],
    exports:      [ SimpleIconsGitComponent ],
    bootstrap:    []
})
export class SimpleIconsGitModule {}
